import store from "../store";
import { getUserInfo } from "@/api/user";
export function checkLogin() {
  return sessionStorage.getItem("mm-token") == null ? false : true;
}

export function setToken(token) {
  sessionStorage.setItem("mm-token", token);
}
export function getToken() {
  return sessionStorage.getItem("mm-token") || "";
}

export function removeToken() {
  sessionStorage.removeItem("mm-token");
}
